// @ts-strict-ignore
/**
 * @fileoverview
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../../reactQueryFetcherAdapters";
import { internalUserGroupsCacheKey } from "./constants";
import type { InternalUserGroupsResult } from "./types";

export const getInternalUserGroups = reactQueryFetcherAdapter(
  internalUserGroupsCacheKey,
  (signal: AbortSignal, groupProperty?: string): Promise<InternalUserGroupsResult> => {
    return fetch(
      "/internal_user_groups/internal_user_groups_data",
      "GET",
      { group_property: groupProperty },
      { signal }
    );
  }
);
